import React, { FunctionComponent } from 'react';
import './ManglerTilganger.css';
import { Heading, LinkPanel } from '@navikt/ds-react';
import { Lenkepanel } from '../../GeneriskeElementer/Lenkepanel';
import { SimpleBanner } from '../Banner';
import { Alerts } from '../Alerts';

export const ManglerTilganger: FunctionComponent = () => {
    return (
        <>
            <SimpleBanner />
            <div className="ingen-tilgang-bakgrunn">
                <Alerts />

                <Heading size="large" level="1">
                    Du mangler tilganger som arbeidsgiver
                </Heading>

                <span className="ingen-tilgang-container">
                    <Lenkepanel href={'https://www.nav.no/person/dittnav/'}>
                        <LinkPanel.Title>Se tjenester som privatperson</LinkPanel.Title>
                        <LinkPanel.Description>Gå til din innloggede side</LinkPanel.Description>
                    </Lenkepanel>

                    <Lenkepanel href={'https://www.nav.no/arbeidsgiver/tilganger'}>
                        <LinkPanel.Title>Hvordan får jeg tilgang?</LinkPanel.Title>
                        <LinkPanel.Description>
                            Lær om roller og tilganger i Altinn
                        </LinkPanel.Description>
                    </Lenkepanel>
                </span>
            </div>
        </>
    );
};
